import { FieldArray } from "formik";
import React from "react";
import { type QuestionFormProps } from "features/Library/Common/props";
import styles from "features/Library/Common/QuestionsForm/QuestionForm.module.scss";

export const QuestionForm = (props: QuestionFormProps) => {
  return (
    <div className={styles.container}>
      <FieldArray name={"questions"} validateOnChange={false} render={props.renderQuestionBuilder} />
    </div>
  );
};

export default QuestionForm;
